import { gql } from '@apollo/client';

const GET_LISTING_TILES = gql`
  query ($listingId: String, $layerType: LayerType!, $page: Int, $limit: Int) {
    tiles(
      listingId: $listingId
      layerType: $layerType
      page: $page
      limit: $limit
    ) {
      items {
        id
        extent {
          points {
            lat
            lng
          }
        }
        zoom
        x
        y
      }
      hasNext
      page
      limit
      totalCount
    }
  }
`;

export { GET_LISTING_TILES };
